import React from 'react';
import { Link } from 'react-router-dom';
import { UserShape } from '../shapes';

export default class AccountDangerZone extends React.Component {

  static propTypes = {
    user: UserShape
  }

  render() {
    return(
      <div className='user-delete-account sidebar'>
        <b>Danger Zone</b>
        <div>
          <Link to='/account/delete'>Delete Account</Link>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/account_danger_zone.jsx